import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useState } from 'react';
var ToolbarDropdownMenuContext = /*#__PURE__*/createContext(undefined);
export var useToolbarDropdownMenu = function useToolbarDropdownMenu() {
  return useContext(ToolbarDropdownMenuContext);
};
export var ToolbarDropdownMenuProvider = function ToolbarDropdownMenuProvider(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenInternal = _useState2[0],
    setIsOpenInternal = _useState2[1];
  var openMenu = function openMenu() {
    if (setIsOpen !== undefined) {
      setIsOpen(true);
    } else {
      setIsOpenInternal(true);
    }
  };
  var closeMenu = function closeMenu() {
    if (setIsOpen !== undefined) {
      setIsOpen(false);
    } else {
      setIsOpenInternal(false);
    }
  };
  var contextValue = {
    openMenu: openMenu,
    closeMenu: closeMenu,
    isOpen: isOpen !== undefined ? isOpen : isOpenInternal
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownMenuContext.Provider, {
    value: contextValue
  }, children);
};